module.exports = __webpack_public_path__ + "img/tg_01 (6).af64fd57.jpg";